var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-tenant"},_vm._l((_vm.tenants),function(tenant,index){return _c('a',{key:index,attrs:{"href":tenant.url}},[_c('img',{attrs:{"src":_vm.resourceUrl(tenant.image),"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }